export default __webpack_public_path__ + "static/Room-With-A-View-Times-Square-4175dcf38a846217536941d1e4f412c7.jpg";